<template>
  <router-view />
</template>

<script>
export default {
  name: 'SubjectsIndex'
}
</script>
